import { render } from "./Q2-3-Greeting.vue?vue&type=template&id=1aa101bc"
import script from "./Q2-3-Greeting.vue?vue&type=script&lang=js"
export * from "./Q2-3-Greeting.vue?vue&type=script&lang=js"

import "./Q2-3-Greeting.vue?vue&type=style&index=0&id=1aa101bc&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__